import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';
import ScrollMemoryWrapper from '../ScrollMemoryWrapper';
import RegistrationCountdown from '../RegistrationCountdown';

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const FixedTop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10001;
`;

const MainContent = styled.main`
  flex: 1;
  padding-top: ${(p) => p.$offset}px;
  min-height: calc(100vh - ${(p) => p.$offset}px);
`;

const Layout = ({ children, enableScrollMemory = false }) => {
  const topRef = useRef(null);
  const [topOffset, setTopOffset] = useState(70);

  useEffect(() => {
    const el = topRef.current;
    if (!el || typeof ResizeObserver === 'undefined') {
      if (el) setTopOffset(el.offsetHeight || 70);
      return undefined;
    }
    const ro = new ResizeObserver(() => {
      setTopOffset(el.offsetHeight || 70);
    });
    ro.observe(el);
    setTopOffset(el.offsetHeight || 70);
    return () => ro.disconnect();
  }, []);

  return (
    <LayoutContainer>
      <FixedTop ref={topRef}>
        <RegistrationCountdown variant="pinned" />
        <Header embedded />
      </FixedTop>
      <ScrollMemoryWrapper enableScrollMemory={enableScrollMemory}>
        <MainContent $offset={topOffset}>
          {children}
        </MainContent>
      </ScrollMemoryWrapper>
      <Footer />
    </LayoutContainer>
  );
};

export default Layout;
